module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app"
    }
  }, [(_vm.$auth.isLogin) ? _c('headbar') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "syn-container"
  }, [_c('router-view', {
    attrs: {
      "toast": _vm.toast,
      "option": _vm.option
    }
  })], 1), _vm._v(" "), (_vm.snackbar) ? _c('mu-snackbar', {
    attrs: {
      "message": _vm.toastMessage
    },
    on: {
      "actionClick": _vm.hideToast,
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c573cb4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 430
// module chunks = 1